<alert type="info">
  <!-- <a href="https://www.boe.ca.gov/prop19/" target="_blank">
    <alert type="info">
      {{ "Prop19.Prop19Infov2" | translate }}
    </alert>

  </a> -->
  <!-- <p style="margin-top: .8rem"><strong>IMPORTANT:</strong> To receive Homeowner Alert Service (e-Notification), <a ngbPopover="Temporarily Disabled" triggers="mouseenter:mouseleave" >register today</a> and select the <strong><i>Opt-In for AIN/Recorded Document email notification</i></strong></p> -->
  <p style="margin-top: .8rem"><strong>IMPORTANT:</strong> To receive Homeowner Alert Service (e-Notification), <a [href]="envService.loginUrl" target="_blank">register today</a> and select the <strong><i>Opt-In for AIN/Recorded Document email notification</i></strong></p>
</alert>

<app-leveltwo [pageName]="'E-Notifications'">
  <div class="General">
    <h3>{{ "Homeowner Alert Service" | translate }}</h3>
    <h4>{{ "e-Notification" | translate }}</h4>
    <p>{{ "Newsletter.AlertDescv2" | translate }} </p>
    <div style="display: flex; gap: 10px">
      <a [class]="buttonClass" [ngbTooltip]="buttonToolTip" [attr.href]="siteConfigService.isGlobalMaintenanceEFI() ? null : envService.loginUrl" target="_blank">
        <span>{{ "Register Today!" | translate }}</span>
      </a>
      <a [class]="buttonClass" [ngbTooltip]="buttonToolTip" [attr.href]="siteConfigService.isGlobalMaintenanceEFI() ? null : envService.portalUrl" target="_blank">
        <span>{{ "Existing Users" | translate }}</span>
      </a>
      <a class="btn btn-primary" [ngbTooltip]="buttonToolTip" href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1691676902/Msc/ASSR_eNotification_Guide.pdf" target="_blank">
        <span>{{ "Instructions Guide" | translate }}</span>
      </a>
    </div>
  </div>

</app-leveltwo>

<!--
<div>
  <tabset>
    <tab heading="{{'LV2Tabs.GeneralInfo'|translate}}">
      <div class="General">
        <h3>{{ "E-NOTIFICATION" | translate }}</h3>
        <h4>{{ "Newsletter.PropertyOwnerAlert" | translate }}</h4>
        <p>{{ "Newsletter.AlertDesc" | translate }} </p>
        <a class="btn btn-primary mb-4 mr-3" [href]="csrUrl" target="_blank">
          <span>{{ "Register Today!" | translate }}</span>
        </a>
        <a class="btn btn-primary mb-4" [href]="envService.portalUrl" target="_blank">
          <span>{{ "Existing Users" | translate }}</span>
        </a>
      </div>
    </tab>
    <tab heading="{{'LV2Tabs.FAQ'|translate}}">
      <div class="General accordion"> -->
        <!-- <accordion [isAnimated]="true">
          <accordion-group #drop [isOpen]="false">
            <div accordion-heading>
              <span class="dropdown-item clearfix">
                FAQ
                <i
                  class="mt-1 float-end"
                  [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
                ></i>
              </span>
            </div> -->
            <!-- <div class="PropAlertBody" >
              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WhatisPropAlert" | translate }}</h6>
              <p [innerHTML]="'Newsletter.ThePropAlert'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.HowtoEnroll" | translate }}</h6>
              <p>To enroll in Property Owner e-Notification Alert, you will need to create a profile on the Los Angeles County Assessor's portal - <a [href]="envService.csrUrl" target="_blank">Register Here!</a><strong> (Please select Opt-In for AIN/Recorded Document email notification)</strong> Once you have created an account, log in to the <a [href]="envService.portalUrl" target="_blank">portal</a> and select "Property Owner e-Notification Alerts" on the landing page. Enter your AIN (Assessor Identification Number) on the "Property Owner e-Notification Registration" page and select "Add." Once you have added your AIN to your account, you will begin to receive electronic notifications when a document is recorded with your linked AIN. If you don't know your AIN, use the <a href="https://assessor2-dev.apps.ocpdev.lacounty.gov/homeowners/property-search" target="_blank">Property Search Tool</a>. You may repeat this step to register other properties on your account.</p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.IsThereaLimit" | translate }}</h6>
              <p [innerHTML]="'Newsletter.ThereisNoLimit'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WhyistheCounty" | translate }}</h6>
              <p [innerHTML]="'Newsletter.TheCounty'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WillthePaper" | translate }}</h6>
              <p [innerHTML]="'Newsletter.ENotification'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.IsthereaFee" | translate }}</h6>
              <p [innerHTML]="'Newsletter.NoFee'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WillIContinue" | translate }}</h6>
              <p [innerHTML]="'Newsletter.OnceYouEnroll'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.AreTheProperty" | translate }}</h6>
              <p [innerHTML]="'Newsletter.TheNotifications'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WhotoContact" | translate }}</h6>
              <p [innerHTML]="'Newsletter.ToSpeak'|translate"></p>

              <h6 style="margin-bottom: 0rem;">{{ "Newsletter.HowtoOptOut" | translate }}</h6>
              <p [innerHTML]="'Newsletter.ToOptOut'|translate"></p>

            </div> -->
          <!-- </accordion-group>
        </accordion> -->
      <!-- </div>
    </tab>


  </tabset> -->
<!-- </div> -->
